import { render } from "./customer_curlec_search.vue?vue&type=template&id=53bd42e8"
import script from "./customer_curlec_search.vue?vue&type=script&lang=js"
export * from "./customer_curlec_search.vue?vue&type=script&lang=js"

import "./customer_curlec_search.vue?vue&type=style&index=0&id=53bd42e8&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__